import TimeseriesBarChart from "./TimeseriesBarChart";
import { formatDate, formatName } from "./MonthDrilldown";

const sessionDrilldownConfig = {
    itemsKey: "notes",
    countKey: "pairsWithSession",
    summary: "logged at least one session",
    activeTabLabel: "Met",
    inactiveTabLabel: "No sessions",
    itemsColumn: {
        label: "Sessions",
        width: "2fr",
        render: (pair) => (
            <div>
                {pair.notes.map((n) => {
                    const author =
                        n.authorRole === "Mentor" ? pair.mentor : pair.mentee;
                    return (
                        <p key={n.id}>
                            {formatDate(n.meetingDate)} ·{" "}
                            {n.type === "InPerson" ? "In person" : "Virtual"}{" "}
                            <span className="card-label neutral">
                                · logged by {formatName(author)} (
                                {n.authorRole.toLowerCase()})
                            </span>
                        </p>
                    );
                })}
            </div>
        ),
    },
};

export default function SessionsChart({ programId }) {
    return (
        <TimeseriesBarChart
            programId={programId}
            endpoint="sessions"
            dataKey="rateOfCompletedSessions"
            seriesName="Completed Sessions Rate"
            drilldownConfig={sessionDrilldownConfig}
        />
    );
}
